var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Core',{attrs:{"avatar":_vm.avatar,"nickname":_vm.nickname,"avatarSize":_vm.avatarSize,"avatarMarginRight":_vm.avatarMarginRight}})}
var staticRenderFns = []

export { render, staticRenderFns }